 //获取sessionStorage的值
 let getSession = (key) => {
  
  // let res = JSON.parse(sessionStorage.getItem(key)) 
  let res = null
  try {
    res =JSON.parse(sessionStorage.getItem(key)) 
  } catch (error) {
    
  }
  if(!res){
    res = false;
  }

  return res;
}

//设置sessionStorage的值
let setSession = (key, value) => {
  sessionStorage.setItem(key, JSON.stringify(value))
}

let getLocal = (key) => {
  // console.log('localStorage.getItem(key)',localStorage.getItem(key))
  let res = null
  try {
    res =JSON.parse(localStorage.getItem(key)) 
  } catch (error) {
    
  }
  // let res =JSON.parse(localStorage.getItem(key)) 
  if(!res){
    res = false;
  }

  return res;
}

let setLocal = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value))
}

let getSession1 =  (key) => {
  let res = null
  try {
    res =JSON.parse(sessionStorage.getItem(key)) 
  } catch (error) {
    
  }
  if(!res){
    res = false;
  }
  return res;
}

let setSession1 = (key, value) => {
  sessionStorage.setItem(key, value)
}

let getLocal1 = (key) => {
  let res = null
  try {
    res =JSON.parse(localStorage.getItem(key)) 
  } catch (error) {
    
  }
  if(!res){
    res = false;
  }

  return res;
}

let setLocal1 = (key, value) => {
  localStorage.setItem(key, value)
}






export default {getSession,setSession,getLocal,setLocal,getSession1,setSession1,getLocal1,setLocal1}